import styled from 'styled-components';

const Line = styled.div`
    border-top: 1px solid ${({ theme }) => theme.gray_5};
`;

export default Line;
